var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTagUser({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 24 24",
    fill: "none",
    shapeRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 15C14.1 15.8 12.9 16.25 11.6 16.25C8.45 16.25 5.9 13.7 5.9 10.55C5.9 7.4 8.45 4.85 11.6 4.85C14.75 4.85 17.3 7.4 17.3 10.55"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.6,
    cy: 10.55,
    r: 2.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.85 8.4V10.7C13.85 11.75 14.55 12.45 15.5 12.45"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.35,
    cy: 14.45,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.35 17.9C15.7 16.95 16.4 16.4 17.35 16.4C18.3 16.4 19 16.95 19.35 17.9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagUser);
export default __webpack_public_path__ + "static/media/tag_user.7b4b8c970d1c3e496a986d1434fa1390.svg";
export { ForwardRef as ReactComponent };